import { NgModule } from '@angular/core';
import { SuperLibComponent } from './super-lib.component';

@NgModule({
  declarations: [SuperLibComponent],
  imports: [
  ],
  exports: [SuperLibComponent]
})
export class SuperLibModule { }
